type NavBarBottomProps = {
  displayLeft?: string
  displayRight: string
}

const NavBarBottom = ({ 
  displayLeft = '',
  displayRight = ''
}: NavBarBottomProps) => {
  
  return <nav className="fixed flex flex-wrap items-center justify-between px-3 py-0.5 text-gray-300 text-xs bg-header z-[1030] bottom-0 left-0 right-0">
    <span>{displayLeft}</span>
    <span>{displayRight}</span>
  </nav>
}

export default NavBarBottom